module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img263-f31274cc3a4134e8e5eed0cc291144c5.jpg";